export default __webpack_public_path__ + "static/media/angpao.a1b25298.webp";